var popupTimerActive = false;

function AddEvent(obj, evt, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false);
    }
    else if (obj.attachEvent) {
        obj.attachEvent("on" + evt, fn);
    }
}

function CheckForSystemPopups() {
    document.querySelectorAll('.system-popup').forEach(function (systemPopup) {

        // Check if popup is marked expired either via internal flag or data attribute
        var popupExpired = (systemPopup._popupExpired === true) || (systemPopup.dataset.popupExpired === 'true');
        //var popupExpired = false; // For Testing
        if (popupExpired) {
            // If the popup is expired then do nothing
            return;
        }

        var popupTimerAttr = systemPopup.getAttribute('data-popup-timeout');
        var popupTimer = popupTimerAttr !== null ? parseInt(popupTimerAttr, 10) : (systemPopup.dataset.popupTimeout ? parseInt(systemPopup.dataset.popupTimeout, 10) : undefined);
        var popupTigger = systemPopup.getAttribute('data-popup-trigger') || systemPopup.dataset.popupTrigger;

        if (popupTigger == "timer") {
            // If we have a popup with a timer
            if (popupTimer != undefined && popupTimer > 0) {
                // If there are no current popups counting down, then add this popup as the current one
                if (popupTimerActive == false) {
                    popupTimerActive = true;
                    setTimeout(function () {
                        systemPopup.classList.add('active');
                    }, popupTimer * 1000);
                } else {
                    // Else set a timeout to load this function again in 10 seconds.
                    setTimeout(function () {
                        CheckForSystemPopups();
                    }, 10000);
                }
            } else {
                // No timer, so there will be no popup
            }
        } else if (popupTigger == "onexit") {
            // Else set a timeout to load this function again in 10 seconds.
            setTimeout(function () {
                AddEvent(document, 'mouseout', function (evt) {
                    if (evt.toElement == null && evt.relatedTarget == null) {
                        var popupExpiredInner = (systemPopup._popupExpired === true) || (systemPopup.dataset.popupExpired === 'true');
                        if (!popupExpiredInner) {
                            systemPopup.classList.add('active');
                        }
                    }
                });
            }, popupTimer);
        }

    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.system-popup').forEach(function (systemPopup) {
        var popupKey = systemPopup.getAttribute('data-popup-key') || systemPopup.dataset.popupKey;
        var popupCookieExpiresAttr = systemPopup.getAttribute('data-popup-cookie-expires') || systemPopup.dataset.popupCookieExpires;
        var popupCookieExpires = popupCookieExpiresAttr !== undefined && popupCookieExpiresAttr !== null ? parseInt(popupCookieExpiresAttr, 10) : undefined;
        var forcePopupCookieExpiredAttr = systemPopup.getAttribute('data-force-popup-cookie-expired') || systemPopup.dataset.forcePopupCookieExpired;
        var forcePopupCookieExpired = (forcePopupCookieExpiredAttr === 'true' || forcePopupCookieExpiredAttr === true);

        // Check to see if the popup is currently expired (cookie-based)
        if (typeof Cookies !== 'undefined' && Cookies.get && Cookies.get('popup_' + popupKey + '_closed') == 'yes') {
            systemPopup._popupExpired = true;
        } else {
            systemPopup._popupExpired = false;
        }

        // If the popup is forcibly expired (return from email popup for example)
        if (forcePopupCookieExpired) {
            if (typeof Cookies !== 'undefined' && Cookies.set) {
                Cookies.set('popup_' + popupKey + '_closed', 'yes', { expires: popupCookieExpires, path: '/' });
            }
            systemPopup.classList.add('active');
        }

        // Add the close functionality
        systemPopup.querySelectorAll('.system-popup-close').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                // Hide the popup
                var closest = btn.closest('.system-popup') || systemPopup;
                closest.classList.remove('active');

                // Make sure the popup is expired now (cookie)
                if (typeof Cookies !== 'undefined' && Cookies.set) {
                    Cookies.set('popup_' + popupKey + '_closed', 'yes', { expires: popupCookieExpires, path: '/' });
                }
                systemPopup._popupExpired = true;

                // Remove the timer active setting now that the
                popupTimerActive = false;

                // Once the popup is closed, check for any new popups.
                CheckForSystemPopups();
            });
        });
    });

    // Check for popups
    CheckForSystemPopups();
});


